const isRange = (date) => {
  if (date === null) {
    return false;
  }
  return typeof date === "object" && ("start" in date || "end" in date);
};
export {
  isRange as i
};
//# sourceMappingURL=model-value-parser.js.map
